module.exports = __webpack_public_path__ + "../resources/images/SkyCode_25-bb8c6d958c3a206c026a6e3c0c1d8a3a.svg";